<template>
  <div :class="$style.box">
    <!-- 文本展开 -->
    <section v-if="showTotal">
      <div ref="showTotal" :class="$style['show-total']">
        <slot name="content"></slot>
      </div>
      <div @click.stop="showTotal = false" :class="$style['fload-btn']">
        <slot name="floadBtn"></slot>
      </div>
    </section>

    <!-- 文本折叠 -->
    <section v-else>
      <div ref="showPart" :class="$style['show-part']">
        <slot name="content"></slot>
      </div>
      <div v-if="showUnfloadBtn" @click.stop="showTotal = true" :class="$style['unflod-btn']">
        <slot name="unfloadBtn"></slot>
      </div>
    </section>

    <!-- 文本展开复制 -->
    <div ref="copyTotal" :class="$style['copy-content']">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showTotal: false,
      showUnfloadBtn: false, // 是否显示展开按钮
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showUnfloadBtn = this.$refs.showPart.offsetHeight < this.$refs.copyTotal.offsetHeight ? true : false
    })
  },
  updated() {
    const showHeight = this.$refs.showPart && this.$refs.showPart.offsetHeight
    const copyHeight = this.$refs.copyTotal && this.$refs.copyTotal.offsetHeight
    this.showUnfloadBtn = showHeight < copyHeight ? true : false
  },
}
</script>
<style lang="scss" module>
@import '~@/styles/mixins.scss';
.box {
  line-height: 15px;
  word-wrap: break-word;
  word-break: break-all;
}
.show-total {
  line-height: 15px;
}
.flod-btn {
  height: 15px;
  text-align: center;
}
.show-part {
  max-height: 30px; // 最多显示两行
  line-height: 15px;
  overflow: hidden;
}
.unflod-btn {
  width: 100%;
  text-align: right;
}
.copy-content {
  position: absolute;
  line-height: 15px;
  visibility: hidden;
}
</style>
